import React from "react";

interface EloIconProps {
  size?: number; // Controla a altura do ícone mantendo a proporção retangular
}

export const EloIcon: React.FC<EloIconProps> = ({ size = 20 }) => {
  const width = size * (638 / 234);

  return (
    <svg
      width={width}
      height={size}
      viewBox="0 0 638 234"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
      <title>Elo icon</title>
      <g id="elo" fillRule="nonzero">
        <path
          d="M95.7,51.6 C102.5,49.3 109.8,48.1 117.4,48.1 C150.6,48.1 178.3,71.7 184.6,103 L231.6,93.4 C220.8,40.2 173.8,0.1 117.4,0.1 C104.5,0.1 92.1,2.2 80.5,6.1 L95.7,51.6 Z"
          id="Shape-Yellow"
          fill="#FFF100"
        />
        <path
          d="M40.2,204 L72,168 C57.8,155.4 48.9,137.1 48.9,116.6 C48.9,96.2 57.8,77.8 72,65.3 L40.2,29.4 C16.1,50.8 0.9,81.9 0.9,116.7 C0.9,151.4 16.1,182.6 40.2,204 Z"
          id="Shape-Blue"
          fill="#00A3DF"
        />
        <path
          d="M184.6,130.4 C178.2,161.7 150.6,185.2 117.4,185.2 C109.8,185.2 102.5,184 95.6,181.7 L80.4,227.2 C92,231.1 104.5,233.2 117.4,233.2 C173.8,233.2 220.8,193.2 231.6,140 L184.6,130.4 Z"
          id="Shape-Red"
          fill="#EE4023"
        />
        <g
          id="Group-Letters"
          transform="translate(287.000000, 29.000000)"
          fill="#ffffff"
        >
          <path
            d="M101.2,133.6 C93.4,141.2 82.9,145.8 71.3,145.6 C63.3,145.5 55.9,143.1 49.7,139.1 L34.1,163.9 C44.8,170.6 57.3,174.6 70.9,174.8 C90.6,175.1 108.6,167.3 121.7,154.6 L101.2,133.6 Z M73,32.5 C33.8,31.9 1.4,63.3 0.8,102.5 C0.6,117.2 4.8,131 12.3,142.4 L141.1,87.3 C133.9,56.4 106.3,33.1 73,32.5 Z M30.3,108.1 C30.1,106.5 30,104.8 30,103.1 C30.4,80 49.4,61.5 72.5,61.9 C85.1,62.1 96.3,67.8 103.8,76.8 L30.3,108.1 Z M181.6,0.5 L181.6,137.8 L205.4,147.7 L194.1,174.8 L170.5,165 C165.2,162.7 161.6,159.2 158.9,155.2 C156.3,151.2 154.3,145.6 154.3,138.2 L154.3,0.5 L181.6,0.5 Z"
            id="Shape-E-L"
          />
          <path
            d="M267.5,64 C271.7,62.6 276.1,61.9 280.8,61.9 C301.1,61.9 317.9,76.3 321.8,95.4 L350.5,89.5 C343.9,57 315.2,32.6 280.8,32.6 C272.9,32.6 265.3,33.9 258.3,36.2 L267.5,64 Z M233.6,156.9 L253,135 C244.3,127.3 238.9,116.1 238.9,103.6 C238.9,91.1 244.4,79.9 253,72.3 L233.6,50.4 C218.9,63.4 209.6,82.5 209.6,103.7 C209.6,124.9 218.9,143.9 233.6,156.9 Z M321.8,112.1 C317.9,131.2 301,145.6 280.8,145.6 C276.2,145.6 271.7,144.8 267.5,143.4 L258.2,171.2 C265.3,173.6 272.9,174.9 280.8,174.9 C315.2,174.9 343.9,150.5 350.5,118 L321.8,112.1 Z"
            id="Shape-O"
          />
        </g>
      </g>
    </svg>
  );
};
